export enum AuthTabEnum {
  Login = 'login',
  Register = 'register',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
}

export enum ImageStateEnum {
  Normal = 'normal',
  Disabled = 'disabled',
  Selected = 'selected',
}

export enum BehaviorScrollToTop {
  Smooth = 'smooth',
  Instant = 'instant',
  Auto = 'auto',
}

export const ModalWelcomeValue = {
  Show: 'show',
  Hidden: 'hidden'
}

